/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import controller from './controllers/classaveragedifferenceController';
import template from './views/classaverage_difference.html';
var module = angular.module('termDifference', [
    //import modules
]).controller('termDifference', controller);

module.constant('termDifference', {
})
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('termDifference', {
//             parent: 'app',
//             url: '/term-difference',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'termDifference'
//                 }
//             }
//         })

// });



// WEBPACK FOOTER //
// ./src/app/educore_reports/school/classaverageDiff.js